// @flow
import * as React from 'react';
import { Box, Text } from '@locus-taxy/neo-ui';

const Option = ({
    innerProps,
    innerRef,
    isFocused,
    data
}: $FixMe): React.Node => (
    <Box
        {...innerProps}
        ref={innerRef}
        color="black"
        px={4}
        py={2}
        backgroundColor={isFocused ? 'blue.100' : 'none'}
        cursor="default"
    >
        <Text size="regular" sx={{ cursor: 'default' }}>
            {data.settingText}
        </Text>
        <Text size="small" color="grey.600" sx={{ cursor: 'default' }}>
            {data.label}
        </Text>
    </Box>
);

export default Option;
